module.exports = __webpack_public_path__ + "static/media/PyTorch.682b59a5.png";